<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" lg="6" sm="12">
                <v-card outlined>
                    <v-list-item>
                        <v-list-item-avatar>
                            <v-icon>mdi-account-box</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">基本情報</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                        <v-form ref="user_profile_form" v-model="valid" @submit.prevent>
                            <v-text-field label="名前" v-model="name" :counter="10" :rules="nameRules" required dense outlined>
                                <template v-slot:append>
                                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                                </template>
                            </v-text-field>
                            <v-text-field label="メールアドレス" v-model="email" :rules="emailRules" required dense outlined>
                                <template v-slot:append>
                                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                                </template>
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn depressed color="primary" @click.prevent="checkDialog" :disabled="!valid">確認</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="12" lg="5" sm="12">
                <v-card class="ml-2" outlined>
                    <v-list-item>
                        <v-list-item-avatar>
                            <v-icon>mdi-onepassword</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">パスワード設定</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                        <v-form ref="user_profile_password_form" v-model="passwordValid" @submit.prevent>
                            <v-text-field type="password" label="パスワード" v-model="password" :counter="16" :rules="passwordRules" required dense outlined>
                                <template v-slot:append>
                                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                                </template>
                            </v-text-field>
                            <password v-model="password" :strength-meter-only="true" @score="showScore"/>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" @click.prevent="passwordCheckDialog" :disabled="!passwordValid">確認</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
                @updated="submit" @canceled="dialogCancel"/>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="passwordDialogDrawer" persistent :max-width="dialogMaxWith">
                <v-card>
                    <v-card-title class="headline">{{ passwordDialogTitle }}</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed @click.stop="passwordDialogCancel" color="grey lighten-1">キャンセル</v-btn>
                        <v-btn depressed color="warning" @click.stop="passwordSubmit">更新</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import { UserStateActions } from "@/store/module/user-state"
  import UserMasterApi from "@/api/user-master-api"
  import Password from "vue-password-strength-meter"
  import Rule from "@/validation/rules"
  import CustomDialog from "@/components/custom_ui/CustomDialog"
  import statusList from "@/helpers/const";

  export default {
    name: "UserProfile",
    components: {
        Password,
        CustomDialog
    },
    props: ["user"],
    data: () => ({
        loading: false,
        // フォーム項目
        name: "",
        email: "",
        password: "",
        passwordRuleslength: 0,
        passwordScore: 0,
        scoreApproveLevel: 3,

        // 更新ダイアログ
        dialogMaxWith: 500,
        dialogTitle: "",
        dialogItems: [],
        dialogDrawer: false,

        // パスワード更新ダイアログ
        passwordDialogTitle: "",
        passwordDialogDrawer: false,

        // バリデーション
        valid: true,
        nameRules: Rule.nameRules,
        emailRules: Rule.emailRules,

        passwordValid: true,
        passwordRules: Rule.passwordRules
    }),
    created() {
        this.initialize();
    },
    methods: {
        isLoading() {
            this.loading = !this.loading;
            this.$emit("loading", this.loading);
        },
        initialize() {
            this.userMasterApi = new UserMasterApi();
            if (this.user) {
                this.name = this.user.user_name;
                this.email = this.user.email;
            }
            this.passwordRuleslength = this.passwordRules.length
        },
        showScore (score) {
            this.passwordScore = score
            if (this.passwordRules.length > this.passwordRuleslength) {
                this.passwordRules.pop()
            }
            if (this.passwordScore < this.scoreApproveLevel) {
                this.passwordRules.push("パスワードの強度がたりません")
            }
        },
        checkDialog() {
            this.dialogTitle = "更新しますか？",
            this.dialogItems = [
                { name: "名前", value: this.name },
                { name: "メールアドレス", value: this.email },
            ]
            this.dialogDrawer = true
        },
        dialogCancel() {
            this.dialogDrawer = false
        },
        submit() {
            if (this.$refs.user_profile_form.validate()) {
                this.isLoading();
                const params = {
                    name: this.name,
                    profile_icon_name: this.name.slice(0,1),
                    email: this.email
                };
                const promise = this.userMasterApi.update(this.user.user_id, params);
                promise.then((response) => {
                    // セッション情報オブジェクトを更新
                    this.user.user_name = this.name;
                    this.user.email = this.email;
                    this.user.icon_name = this.name.slice(0,1);

                    // セッションストレージ内の情報を更新
                    this.$store.dispatch(UserStateActions.setUser, this.user);
                    this.$emit('success', response.data.message);
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if (error.response) {
                        if (error.response.data.status == statusList.status.authError) {
                            this.dialogDrawer = false;
                            this.$emit('logoutConform');
                        } else if (error.response.data.status == statusList.status.entityError) {
                            this.$emit("error",error.response.data.message);
                            this.$router.push({ name: "Dashboard" })
                        } else {
                            this.$emit("error",error.response.data.message);
                        }
                    } else {
                        this.$emit("error","サーバーエラーが発生しました。");
                    }
                }).finally(() => {
                    this.isLoading();
                });
                this.dialogDrawer = false;
                this.$refs.user_profile_form.resetValidation();
            }
        },
        passwordCheckDialog() {
            this.passwordDialogTitle = "パスワードを更新しますか？",
            this.passwordDialogDrawer = true;
        },
        passwordDialogCancel() {
            this.passwordDialogDrawer = false;
        },
        passwordSubmit() {
            if (this.$refs.user_profile_password_form.validate()) {
                this.isLoading();
                const params = {
                    password: this.password
                };
                const promise = this.userMasterApi.update(this.user.user_id, params);
                promise.then((response) => {
                    this.$emit('success', response.data.message);
                }).catch(error => {
                    useAppInsights().trackException({exception: error});
                    if (error.response) {
                        if (error.response.data.status == statusList.status.authError) {
                            this.passwordDialogDrawer = false;
                            this.$emit('logoutConform');
                        } else {
                            this.$emit("error",error.response.data.message);
                        }
                    } else {
                        this.$emit("error","サーバーエラーが発生しました。");
                    }
                }).finally(() => {
                    this.isLoading();
                });
                this.password = "";
                this.passwordScore = 0;
                this.passwordDialogDrawer = false;
                this.$refs.user_profile_password_form.resetValidation();
            }
        }
    }
  }
</script>
